const EntitlementInformation = () => (
  <>
    <h2 className="h4">Authorized Computers</h2>
    <hr />
    <p>
      Reason can run offline (without internet) for a limited time (read more{' '}
      <a
        target="_blank"
        rel="noreferrer"
        href="https://help.reasonstudios.com/hc/en-us/articles/10288581394322"
      >
        here
      </a>
      ). You can also authorize up to three computers for long-term offline use
      (for example if you’re travelling or working in a studio without internet
      access). This is done in the Preferences or Settings in Reason.
    </p>

    <p>
      If you have already authorized three computers and want to add a new one,
      you first need to remove the authorization for one of the others:
    </p>

    <div className="ml-30">
      <p>1. Start Reason on that computer</p>
      <p>2. Open the Preferences or Settings window</p>
      <p>
        3. Under Account and Authorization, click “Remove long-term
        authorization”
      </p>
    </div>
    <p className="mb-30">
      <b>
        If you can no longer access the computer, you need to contact support to
        remove its authorization, using the buttons below.
      </b>
    </p>
  </>
)

export default EntitlementInformation
